import { uuid } from '../../uuid'

export default {
    async register({ dispatch }) {
        dispatch('setRegistrationId')
        dispatch('setHrId')
        return
    },

    setRegistrationId({ state, commit }) {
        if (state.registrationId) return

        commit('set', { registrationId: uuid() })
    },

    async setHrId({ state, commit }) {
        if (state.hrId) return

        let results = {}

        try {
            let response = await fetch('api/v3/register')
            if (response.ok) {
                results = await response.json()
            }
        }
        catch (e) {
            console.log(e)
        }
        if (results.hrId) {
            commit('set', { hrId: results.hrId })
        }
        return
    }
}
